import Swal from "sweetalert2";

// ✅ 成功提示
// ✅ 改成回傳 Promise，支援 async/await
export function showSuccess(message = "操作成功") {
  return Swal.fire({
    icon: "success",
    title: "成功",
    text: message,
    confirmButtonText: "確定",
    timer: 1500, // ✅ 可自動關閉
    timerProgressBar: true, // ✅ 顯示進度條
    showConfirmButton: false, // ✅ 不用手動按「確定」
  });
}

// ✅ 錯誤提示
export function showError(message = "發生錯誤") {
  if (typeof message === "object") {
    // 🔧 自動判斷是否為物件
    try {
      message = message.message || JSON.stringify(message, null, 2);
    } catch {
      message = "發生未知錯誤";
    }
  }

  Swal.fire({
    icon: "error",
    title: "錯誤",
    text: message,
    confirmButtonText: "了解",
  });
}

// ✅ 確認提示（回傳 Promise）
export function showConfirm(message = "你確定要執行此操作嗎？") {
  return Swal.fire({
    icon: "warning",
    title: "請確認",
    text: message,
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "確定",
    cancelButtonText: "取消",
  });
}

// ✅ 提示輸入（回傳 Promise）
export function showPrompt(title = "請輸入資料", inputType = "text") {
  return Swal.fire({
    title,
    input: inputType,
    inputPlaceholder: "請輸入內容",
    showCancelButton: true,
    confirmButtonText: "送出",
    cancelButtonText: "取消",
  });
}

// ✅ Toast 提示（非阻斷）
export function showToast(message = "操作成功", icon = "success") {
  Swal.fire({
    toast: true,
    position: "top-end",
    icon,
    title: message,
    showConfirmButton: false,
    timer: 2000,
    timerProgressBar: true,
  });
}

// ✅ 顯示處理中 loading
export function showLoading(title = "處理中，請稍候...") {
  Swal.fire({
    title,
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });
}

// ✅ 關閉 loading
export function hideLoading() {
  const popup = Swal.getPopup();
  if (popup && popup.classList.contains("swal2-loading")) {
    Swal.close(); // ✅ 只關閉 loading 視窗，不會誤關提示框
  }
}

// ✅ 通用自訂彈窗（支援 html / didOpen / 控制按鈕）
export function showCustom({
  title = "提示",
  text = "",
  html = "",
  icon = "info",
  showConfirmButton = true,
  showCancelButton = false,
  confirmButtonText = "確定",
  cancelButtonText = "取消",
  allowOutsideClick = true,
  didOpen,
  preConfirm,
}) {
  // 若 text 是物件，自動轉字串（保留你原本邏輯）
  if (typeof text === "object") {
    try {
      text = text.message || JSON.stringify(text, null, 2);
    } catch {
      text = "發生未知錯誤";
    }
  }

  return Swal.fire({
    title,
    icon,

    // ⭐ 重點：text / html 擇一
    text: html ? undefined : text,
    html: html || undefined,

    showConfirmButton,
    showCancelButton,
    confirmButtonText,
    cancelButtonText,
    allowOutsideClick,

    didOpen,
    preConfirm,
  });
}
